import { Box, Grid, useTheme } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useCollectCampaignState } from "../../context/CollectCampaignContext";
import { useFetchTable } from "@hooks/useFetchDataTable";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { useFilters } from "@context/filters";
import { useParams } from "react-router-dom";
import { useAuth } from "@context/auth";
import Table from "@components/Table";
import { MRT_RowSelectionState } from "material-react-table";

const Step2 = () => {
  const theme = useTheme();
  const { t } = useTranslation(["collect-campaign-page"]);
  const { id, idCampaign } = useParams();
  const { user } = useAuth();
  const { state, dispatch } = useCollectCampaignState(); //GLOBAL STATE NOTIFICATIONS
  const selectedFromState = state.owners?.reduce(
    (acc: { [key: string]: boolean }, cur: number) => {
      acc[`${cur}`] = true;
      return acc;
    },
    {},
  );
  const [selectedUsers, setSelectedUsers] = useState<MRT_RowSelectionState>(
    !idCampaign ? { [`${user?.id_user}`]: true } : (selectedFromState ?? {}),
  );
  const { filters } = useFilters();
  const filterId = `${user?.id_user}_${PagesID["corporate.collect-campaign.add.owners"]}`;
  const userQuery = new URLSearchParams();
  userQuery.append("corporate_id", id!);
  [
    "BUSINESS_ADMIN",
    "PRODUCT_OWNER",
    "TEACHER",
    "HR",
    "MANAGER",
    // "CONTENT_CREATOR",
    "MACHINE",
    "PROVIDER",
    "TUTOR",
    "ROLE_1",
    "ROLE_2",
    "ROLE_3",
    "ROLE_4",
    "ROLE_5",
    "ROLE_6",
    "ROLE_7",
    "ROLE_8",
    "ROLE_9",
    "ROLE_10",
    "ROLE_11",
    "ROLE_12",
    "ROLE_13",
    "ROLE_14",
    "ROLE_15",
    "ROLE_16",
    "ROLE_17",
    "ROLE_18",
    "ROLE_19",
    "ROLE_20",
  ].forEach((role) => {
    userQuery.append("roles", role);
  });
  const { columns, dataTable, actionsTopToolbar, actionForRow, mutate } =
    useFetchTable(
      `${ServicesURL.digitedUsers}?${userQuery.toString()}`,
      PagesID["corporate.collect-campaign.add.owners"],
      filters[filterId] ?? { pageIndex: 0, pageSize: 20 },
    );

  const handleSelection = (selection: any) => {
    const selectedUsers = Object.keys(selection);
    dispatch({
      type: "SET_OWNERS",
      payload: selectedUsers.map(Number),
    });
    setSelectedUsers(selection);
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        // minHeight: "495px",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Grid
        container
        spacing={3.75}
        sx={{
          justifyContent: "space-between",
        }}
      >
        <Grid
          item
          sx={{
            width: "100%",
          }}
        >
          <Box>
            <Table
              id={PagesID["corporate.collect-campaign.add.owners"]}
              data={dataTable?.output}
              columns={columns || []}
              configurationTopToolbar={[]}
              configurationActionForRow={[]}
              // renderRowActions={customRenderRowActions}
              totalPages={dataTable?.metadata?.total_elements}
              enableRowActions={false}
              enableRowSelection={true}
              enableSelectAll={true}
              selectedRows={selectedUsers}
              getRowId={(row: any) => row.id_user}
              onRowSelectionChange={(selection: any) => {
                handleSelection(selection);
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Step2;
